import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import { useResponsive } from '../../hooks/use-responsive';

import { bgBlur } from '../../theme/css';
import Iconify from '../../theme/iconify/iconify';

import { NAV, HEADER } from './config-layout';

import Language from '../util/Language';
import AccountPopover from '../user/AccountPopover';


function Header({ user, updateUser, onOpenNav }) {
    const theme = useTheme();

    const lgUp = useResponsive('up', 'lg');

    const renderContent = (
        <>
            <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1} sx={{ width: '100%' }}>
                {!lgUp && (
                    <IconButton onClick={onOpenNav} sx={{ mr: 1, pl: 0 }}>
                        <Iconify icon='eva:menu-2-fill' />
                    </IconButton>
                )}
                <Language user={user} updateUser={updateUser} />
                <AccountPopover user={user} updateUser={updateUser} />
            </Stack>
        </>
    );

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(lgUp && {
                    width: `calc(100% - ${NAV.WIDTH + 1}px)`,
                    height: HEADER.H_DESKTOP,
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { lg: 5 },
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}

Header.propTypes = {
    onOpenNav: PropTypes.func,
};

export default Header;
